function GithubLogo() {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 1024 1024"
      height="24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M511.6 76.3C264 76.3 64 277.5 64 525.3c0 198.2 128.4 366.4 306.5 425.8 22.4 4.1 30.5-9.8 30.5-21.7v-79c-124.5 27.4-150.7-55.7-150.7-55.7-20.4-51.7-49.9-65.5-49.9-65.5-40.7-27.8 3.1-27.2 3.1-27.2 44.9 3.1 68.6 46.1 68.6 46.1 40 68.5 104.8 48.7 130.4 37.2 4.1-28.9 15.7-48.7 28.5-59.9-99.6-11.5-204.3-50.1-204.3-222.9 0-49.1 17.3-89.2 45.5-120.6-4.5-11.5-19.9-57.7 4.5-120.2 0 0 37.5-12.2 122.8 45.5 36.1-10.2 75-15.3 113.8-15.3 38.8 0 77.7 5.1 113.8 15.3 85.2-57.7 122.8-45.5 122.8-45.5 24.4 62.4 9 108.7 4.5 120.2 28.2 31.4 45.5 71.5 45.5 120.6 0 173.7-104.8 211.3-204.8 222.3 16.2 14.3 30.5 42.9 30.5 86.6v128.1c0 12.2 9.8 27.8 31.4 21.7 178.1-59.3 306.5-227.5 306.5-425.8 0-247.8-200-448.9-448.4-448.9z"></path>
    </svg>
  );
}

export default GithubLogo;
